import React from 'react';
import cx from 'classnames';

import Image from '@xingternal/malt-image';
import { useMediaListener } from '@xingternal/util';
import { CoverMediaImagesUrlType } from './CoverMediaContainer';

import styles from './CoverMedia.css';
import freeCover from './FreeCover.svg';

type CoverMediaProps = {
  data?: CoverMediaImagesUrlType | null;
  newCover?: string | null;
};

const CoverMedia = ({ data, newCover }: CoverMediaProps) => {
  const breakpoint = useMediaListener();

  return (
    <div
      className={cx(styles.coverImageWrapper, {
        [styles.noImage]: !(data?.[breakpoint] || newCover),
      })}
      data-cy="COVER_IMAGE"
    >
      <div className={styles.coverImageInner}>
        <>
          <div className={styles.coverOverlay} />
          <Image
            data-testid={'COVER_IMAGE'}
            src={newCover || data?.[breakpoint] || freeCover}
            alt="Cover Image"
          />
        </>
      </div>
    </div>
  );
};

export default CoverMedia;
